import React, { useState } from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function FaqSection() {
  const revealRef = useScrollReveal();
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Cuánto tarda en manifestarse el cambio?',
    a: 'El tiempo es proporcional a la profundidad de tu entrega al proceso. Cada vez que dudas, vuelves a colapsar la vieja realidad. No hay un plazo fijo — hay un nivel de confianza. Muchos lectores reportan cambios físicos y emocionales perceptibles en los primeros 7 días de práctica constante.'
  }, {
    q: '¿Funciona si tengo traumas muy graves?',
    a: 'Especialmente si tienes traumas graves. El quiebre profundo es el combustible más potente para un salto de conciencia radical. La profundidad del abismo determina la altura del vuelo que viene después. Los traumas más intensos crean las grietas más grandes por donde entra la luz del campo cuántico.'
  }, {
    q: '¿Cómo recibo el ebook después de pagar?',
    a: 'Inmediatamente después de confirmar tu pago recibirás un correo electrónico con el enlace de descarga en formato PDF. El acceso es instantáneo. Si no ves el correo en 5 minutos, revisa la carpeta de spam.'
  }, {
    q: '¿Para quién es este protocolo?',
    a: 'Para personas de 30 a 55 años que han intentado terapia, libros de autoayuda, afirmaciones o meditación y siguen repitiendo los mismos patrones. No necesitas ningún conocimiento previo de física cuántica — el protocolo te guía desde cero con lenguaje claro y ejercicios aplicables de inmediato.'
  }, {
    q: '¿Qué pasa si no me funciona?',
    a: 'Tienes 7 días de garantía total. Si sientes que el protocolo no produjo ningún cambio en tu percepción o en tu estado interno, escríbenos y te devolvemos el dinero completo, sin preguntas y sin procesos complicados.'
  }];
  return <section className="bg-brand-dark py-10 px-[5%]" data-id="element-23">
      <div ref={revealRef} className="max-w-7xl mx-auto reveal" data-id="element-24">
        <div className="text-center mb-[56px]" data-id="element-25">
          <div className="text-brand-gold text-[11px] uppercase tracking-[0.15em] mb-4" data-id="element-26">
            PREGUNTAS FRECUENTES
          </div>
          <h2 className="font-display italic text-[48px] text-brand-cream leading-tight" data-id="element-27">
            Todo lo que necesitas saber
          </h2>
        </div>

        <div className="max-w-[700px] mx-auto" data-id="element-28">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="border-b border-white/[0.08]" data-id="element-29">
                <button className="w-full flex justify-between items-center py-[22px] text-left group" onClick={() => setOpenIndex(isOpen ? null : i)} data-id="element-30">
                  <span className="font-body text-[17px] font-medium text-brand-cream transition-colors duration-300 group-hover:text-brand-gold" data-id="element-31">
                    {faq.q}
                  </span>
                  <span className={`text-brand-gold text-[20px] transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} data-id="element-32">
                    +
                  </span>
                </button>
                <div className={`overflow-hidden transition-all duration-350 ease-in-out ${isOpen ? 'max-h-[200px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-33">
                  <p className="font-body font-light text-[15px] text-brand-cream/60 leading-[1.75] pb-[20px]" data-id="element-34">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}